import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full"
}
const _hoisted_2 = { class: "flex gap-x-1 flex-wrap mb-2 w-full w-full justify-center" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "h-12 w-15 rounded-2xl bg-white overflow-hidden relative flex items-center justify-center" }
const _hoisted_5 = ["src", "srcset"]
const _hoisted_6 = { class: "text-parameter-text text-[10px] overflow-hidden max-w-15 mx-auto text-center mt-1" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "text-parameter-text text-[10px] overflow-hidden max-w-15 mx-auto text-center mt-1" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "h-12 w-15 rounded-2xl bg-white overflow-hidden relative flex items-center justify-center" }
const _hoisted_11 = ["src", "srcset"]
const _hoisted_12 = { class: "text-parameter-text text-[10px] overflow-hidden max-w-15 mx-auto text-center mt-1" }

import {computed, inject, ref, watch} from "vue";
import {useStore} from "vuex";
import {useI18n} from "vue-i18n";
import {ParametersVariations} from "@/assets/ts/parametersVariations";
import ItemV3StonesParameterLoading
  from "@/components/itemV3/parameter/stones/parameter/itemV3StonesParameterLoading.vue";

const variantIdx = ""


export default /*@__PURE__*/_defineComponent({
  __name: 'itemV3StonesAddons',
  props: {
    groupIdx: {},
    stoneLayout: {}
  },
  emits: ["patch"],
  setup(__props: any, { emit: __emit }) {


const props = __props;
const emit = __emit;

const store = useStore();
const {t} = useI18n();

const loadItemVariants = inject<any>("loadItemVariants");

const itemIdx = inject<any>("itemIdx");
const session = inject<any>("session");

/**
 * session
 *
 * Transferred from itemV3StonesForm.vue: configureAll/itemIdx are wired into
 * ParametersVariations the same way, the variant is fetched per stone group via
 * getItemVariants(itemIdx, "stones.<groupIdx>.stone_addon") instead of a fixed idx.
 */

const configureAll = computed(() => store.getters["session/getConfigureAll"])
const parametersVariations = new ParametersVariations(variantIdx, configureAll, session, itemIdx, loadItemVariants)

/**
 * stone addon - stones.<groupIdx>.stone_addon
 */

const stoneAddon = ref({
  "stone_addon": {}
} as any)

const getStoneAddonData = (groupIdy: number) => {
  if (groupIdy >= 0) {
    stoneAddon.value.stone_addon = parametersVariations.getItemVariants(itemIdx.value, "stones." + groupIdy + ".stone_addon")
  }
}

watch(() => props.groupIdx, (groupIdy) => {
  getStoneAddonData(groupIdy)
}, {immediate: true})

watch(session, () => {
  getStoneAddonData(props.groupIdx)
}, {deep: true})

/**
 * addon variants (transferred from itemV3StonesForm.vue's "form variants")
 */

const active = computed(() => stoneAddon.value.stone_addon[0])

const variantsList = computed(() => active.value?.values || [])

// the current match should always be listed first, so it is always part of the
// directly visible values instead of potentially being hidden behind "more"
const orderedVariantsList = computed(() => {
  // do not show matched addon at first position

  // filter list by comparing props.stoneLayout with variantData.stone_laypout
  const filteredVariantsList = variantsList.value.filter((variantData: any) => variantData.stone_layout === props.stoneLayout)

  return filteredVariantsList
  /**
   * Old variant ordered list, first variant is always first position

   const matchedIdx = variantsList.value.findIndex((v: any) => v.match)
   if (matchedIdx <= 0) {
   return variantsList.value
   }
   const matchedValue = variantsList.value[matchedIdx]
   return [
   matchedValue,
   ...variantsList.value.slice(0, matchedIdx),
   ...variantsList.value.slice(matchedIdx + 1)
   ]
   */
})

// focus mode removed: all values are shown directly, the first 5 right away and the
// rest hidden behind the "more"/"less" toggle below
const visibleValues = computed(() => orderedVariantsList.value.slice(0, 20))

const moreValues = computed(() => orderedVariantsList.value.slice(20))

const hasMoreValues = computed(() => moreValues.value.length > 0)

// whether the "more" values (list entry with the right-arrow) have been revealed inline
const showMore = ref(false)

/**
 * Patch
 */

const handleValuePatch = (actionIdx: string, value: any) => {
  emit('patch', {
    action: actionIdx,
    value: value.idx,
    certificated_diamond: value.certificated_diamond
  });
};

const newIcons = [
  "c391",
  "c281",
  "c66",
  "c31",
  "c22",
  "c21",
  "c18",
  "c17",
  "c5"
]


return (_ctx: any,_cache: any) => {
  return (active.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleValues.value, (variantData, variantIdx) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              (variantData.idx !== '')
                ? (_openBlock(), _createElementBlock("li", {
                    key: variantIdx,
                    class: _normalizeClass(["cursor-pointer flex flex-col items-center py-2 px-1 rounded-2xl hover:bg-[#f3f0e9]", {
              'border-2 border-brand-main bg-[#f3f0e9]': variantData.match,
              'border-2 border-transparent': !variantData.match
            }]),
                    onClick: ($event: any) => (handleValuePatch(active.value.idx, variantData))
                  }, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("img", {
                        src: newIcons.includes(variantData.idx.toLowerCase())
                  ? `https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/parameters/stone_addon/400x300/${variantData.idx.toLowerCase()}.webp`
                  : `https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/parameters/stone_addon/300x300/addon_${variantData.idx.toLowerCase()}.webp`,
                        srcset: newIcons.includes(variantData.idx.toLowerCase())
                  ? `https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/parameters/stone_addon/800x600/${variantData.idx.toLowerCase()}.webp`
                  : `https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/parameters/stone_addon/600x600/addon_${variantData.idx.toLowerCase()}.webp`,
                        class: "w-full h-full object-cover relative"
                      }, null, 8, _hoisted_5)
                    ]),
                    _createElementVNode("span", _hoisted_6, _toDisplayString(variantData.title), 1)
                  ], 10, _hoisted_3))
                : _createCommentVNode("", true)
            ], 64))
          }), 256)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleValues.value, (variantData, variantIdx) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              (variantData.idx === '' && !variantData.match)
                ? (_openBlock(), _createElementBlock("li", {
                    key: variantIdx,
                    class: "cursor-pointer flex flex-col items-center py-2 px-1 rounded-2xl hover:bg-[#f3f0e9] border-2 border-transparent",
                    onClick: ($event: any) => (handleValuePatch(active.value.idx, variantData))
                  }, [
                    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "h-12 w-15 rounded-2xl flex items-center justify-center relative bg-[#f3f0e9]" }, [
                      _createElementVNode("svg", {
                        "aria-hidden": "true",
                        viewBox: "0 0 12 12",
                        fill: "none",
                        class: "size-2.5 shrink-0 text-[#555956]"
                      }, [
                        _createElementVNode("path", {
                          d: "m2.5 2.5 7 7m0-7-7 7",
                          stroke: "currentColor",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        })
                      ])
                    ], -1)),
                    _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)('components.parameters.stones.addons.no_addon')), 1)
                  ], 8, _hoisted_7))
                : _createCommentVNode("", true)
            ], 64))
          }), 256)),
          (hasMoreValues.value && !showMore.value)
            ? (_openBlock(), _createElementBlock("li", {
                key: 0,
                class: "cursor-pointer flex flex-col items-center p-2 px-1 rounded-2xl hover:bg-[#f3f0e9] border-2 border-transparent",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (showMore.value = true))
              }, [...(_cache[3] || (_cache[3] = [
                _createElementVNode("div", { class: "h-12 w-15 rounded-2xl flex items-center justify-center relative bg-[#f3f0e9]" }, [
                  _createElementVNode("svg", {
                    "aria-hidden": "true",
                    viewBox: "0 0 12 12",
                    fill: "none",
                    class: "size-2.5 shrink-0 -rotate-90 text-[#555956]"
                  }, [
                    _createElementVNode("path", {
                      d: "m1.5 4 4.5 4 4.5-4",
                      stroke: "currentColor",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    })
                  ])
                ], -1),
                _createElementVNode("span", { class: "text-parameter-text text-[10px] overflow-hidden max-w-15 mx-auto text-center mt-1" }, " Mehr ", -1)
              ]))]))
            : _createCommentVNode("", true),
          (showMore.value)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(moreValues.value, (variantData, variantIdx) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: 'more-' + variantIdx,
                  class: _normalizeClass(["cursor-pointer flex flex-col items-center py-2 px-1 rounded-2xl hover:bg-[#f3f0e9]", {
              'border-2 border-brand-main bg-[#f3f0e9]': variantData.match,
              'border-2 border-transparent': !variantData.match
            }]),
                  onClick: ($event: any) => (handleValuePatch(active.value.idx, variantData))
                }, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("img", {
                      src: newIcons.includes(variantData.idx.toLowerCase())
                  ? `https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/parameters/stone_addon/400x300/${variantData.idx.toLowerCase()}.webp`
                  : `https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/parameters/stone_addon/300x300/addon_${variantData.idx.toLowerCase()}.webp`,
                      srcset: newIcons.includes(variantData.idx.toLowerCase())
                  ? `https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/parameters/stone_addon/800x600/${variantData.idx.toLowerCase()}.webp`
                  : `https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/parameters/stone_addon/600x600/addon_${variantData.idx.toLowerCase()}.webp`,
                      class: "w-full h-full object-cover relative"
                    }, null, 8, _hoisted_11)
                  ]),
                  _createElementVNode("span", _hoisted_12, _toDisplayString(variantData.title), 1)
                ], 10, _hoisted_9))
              }), 128))
            : _createCommentVNode("", true),
          (showMore.value)
            ? (_openBlock(), _createElementBlock("li", {
                key: 2,
                class: "cursor-pointer flex flex-col items-center py-2 px-1 rounded-2xl hover:bg-[#f3f0e9] border-2 border-transparent",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (showMore.value = false))
              }, [...(_cache[4] || (_cache[4] = [
                _createElementVNode("div", { class: "h-12 w-15 rounded-2xl flex items-center justify-center relative bg-[#f3f0e9]" }, [
                  _createElementVNode("svg", {
                    "aria-hidden": "true",
                    viewBox: "0 0 12 12",
                    fill: "none",
                    class: "size-2.5 shrink-0 rotate-90 text-[#555956]"
                  }, [
                    _createElementVNode("path", {
                      d: "m1.5 4 4.5 4 4.5-4",
                      stroke: "currentColor",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    })
                  ])
                ], -1),
                _createElementVNode("span", { class: "text-parameter-text text-[10px] overflow-hidden max-w-15 mx-auto text-center mt-1" }, " Weniger ", -1)
              ]))]))
            : _createCommentVNode("", true)
        ])
      ]))
    : (_openBlock(), _createBlock(ItemV3StonesParameterLoading, { key: 1 }))
}
}

})